import { HostEnv } from '@jd/paimai-utils';
import unit_institution from '../store/asset_institution/unit_institution';

export const formateTimeNumber = num => num >= 10 ? num : `0${num}`;

export const jumpToWeb = url => window.location.href=url;

export const isEmpty = object => JSON.stringify(object) === '{}' || JSON.stringify(object) === '[]'|| object == undefined;

export const isEmptyArr = object => JSON.stringify(object) === '[""]' || JSON.stringify(object) === '[]'|| object == undefined;

/**
 * 数组深拷贝
 * @param source
 * @returns {*}
 */
export const objDeepCopy =  (source)=> {
  let sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item];
  }
  return sourceCopy;
}

export const subString = (str, num) => {
  if (str.length <= num) {
    return str;
  }
  if (str.length > num) {
    return `${str.substring(0, num)}...`
  }
};

export const addPageTitle = (title) => {
 document.title = title;
};


export const getPageName = (pathname) => {
  let pageNumber = -1;
  pathname.indexOf('/autoMobile') !== -1 ? pageNumber = 1 : pageNumber = pageNumber;
  pathname.indexOf('/autoSearch') !== -1 ? pageNumber = 2 : pageNumber = pageNumber;
  pathname.indexOf('/autoStore') !== -1 ? pageNumber = 3 : pageNumber = pageNumber;
  pathname.indexOf('/bankruptcy') !== -1 ? pageNumber = 4 : pageNumber = pageNumber;
  pathname.indexOf('/ruptcySearch') !== -1 ? pageNumber = 5 : pageNumber = pageNumber;
 return pageNumber;
};

/**
 * 代码埋点
 * @param
 * @returns {*}
 */
export const MpingClick = (eventId, eventParam = false, pageParam = false, pageId = false, JsonParam = false) => {
  try {
    let click = new MPing.inputs.Click(eventId);
    if (eventParam) {
      click.event_param = eventParam;
    }
      if (pageParam) {
        click.page_param = pageParam;
      }
      if (pageId) {
        click.page_id = pageId;
      }
      if (JsonParam) {
        click.json_param = typeof JsonParam === 'object' ? JSON.stringify(JsonParam) : JsonParam;
      }
      click.updateEventSeries();
      let mping = new MPing();
      mping.send(click);
  } catch (e) {
  }
};

/**
 * PV埋点
 * @param
 * @returns {*}
 */
export const PVping = (pageId, pageParam) => {
  try {
    var pv= new MPing.inputs.PV(pageId);   // 构造pv 请求,可选参数为pageId
    var mping = new MPing(); 
    if (pageParam) {
      pv.page_param = typeof pageParam === 'object' ? JSON.stringify(pageParam) : pageParam;
    }        // 构造上报实例
    mping.send(pv);                   // 上报pv
  } catch (e) {
  }
};

export const throttle = (func, wait) => {
  let lastTime = null;
  let timeout;
  return function () {
    let context = this;
    let now = new Date();
    if (now - lastTime - wait > 0) {
      // 如果之前有了定时任务则清除
      if (timeout) {
        clearTimeout(timeout);
        timeout = null
      }
      func.apply(context, arguments);
      lastTime = now
    } else if (!timeout) {
      timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    }
  }
};

// 判断元素是否在可视范围内
export const isElementInViewport = (el, offset = 0) => {
  const box = el.getBoundingClientRect(),
      top = (box.top >= 0),
      left = (box.left >= 0),
      bottom = (box.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset),
      right = (box.right <= (window.innerWidth || document.documentElement.clientWidth) + offset);
  return (top && left && bottom && right);
};

// 定位方法
export const getPositionInfo = (callback, errorCallback) => {
  window.locationTimer = setTimeout(() => {
    errorCallback();
  }, 10000);
  if (isJdapp()) {
    fixedPositionByJdapp();
    window.responsePositionInfo = (dataJsonString) => {
      var baiscInfo = JSON.parse(dataJsonString);
      // 纬度
      var lat = baiscInfo.data.lat;
      // 经度
      var lng = baiscInfo.data.lng;
      clearTimeout(window.locationTimer);
      callback(lat, lng);
      sessionStorage.setItem('autoLoc', 1)
    };
  } else {
    fixedPositionByH5(callback, errorCallback);
  }
}


const fixedPositionByH5 = (callback, errorCallback) => {
    if ("geolocation" in navigator) {
      /* 地理位置服务可用 */
      console.log('地理位置可用')
      navigator.geolocation.getCurrentPosition(function ( position ) {
        clearTimeout(window.locationTimer);
        callback(
            position.coords.latitude,
            position.coords.longitude
        )
        sessionStorage.setItem('autoLoc', 1)
      }, function ( err ) {
        console.error(err);
        errorCallback();
      })
    } else {
      /* 地理位置服务不可用 */
      errorCallback();
      console.log('地理位置不可用')
    }
}

// 判断app环境
export const isJdapp = () => {
  return /jdapp/.test(navigator.userAgent);
}

export const isJdjrApp = () => {
  return /JDJR-App/.test(navigator.userAgent);
}

// 判断IOS
export const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export const isInWXSQ = () => {
  return /AND_SQ|IPH_SQ|micromessenger(\/[\d.]+)*/i.test(window.navigator.userAgent)
}
/**
 * 适配 iphone 左滑返回的方法
 * @param url 目标链接
 * @param openApp 是否使用openapp协议
 * @returns {boolean}
 */
export const webviewRedirect = (url, openApp = true) => {
  var newUrl = url.replace(/http*:/, '')
  var agent = navigator.userAgent.toLowerCase();
  if (!url) {
    return false;
  }
  if (!openApp) {
    window.location.href = newUrl;
    return true;
  }

  if (agent.indexOf('jdapp') >= 0) { // 京东内
    window.location.href = `openApp.jdMobile://virtual?params={"category":"jump","des":"m","action":"to","url":"${encodeURIComponent(window.location.protocol + newUrl)}"}`;
    return true;
  } else {
    window.location.href = newUrl;
    return true;
  }
}

// 判断webview环境
function isWKWebView () {
  const ua = navigator.userAgent;
  return !!ua.match(/supportJDSHWK/i) || window._is_jdsh_wkwebview == 1 ? true : false
  //    true表示是ios商城，false表示是android商城
}

// 与原生端交互
function configNav (jsonString) {
  const isWK = isWKWebView();
  if(isWK){     //WKWebView
    window.webkit.messageHandlers.JDAppUnite.postMessage({
      'method' : 'getPhoneBasicInfo',
      'params' :  jsonString
    });
  }
  else{      //UIWebView和Android
    window.JDAppUnite && window.JDAppUnite.getPhoneBasicInfo(jsonString)
  }
}

const fixedPositionByJdapp = () => {
  configNav('responsePositionInfo')
}

export const changePromParam = (condition) => {
  let returnParams = Object.assign({}, condition);
  const {sortField, categoryIds, currentPriceRangeStart, currentPriceRangeEnd} = returnParams;
  if (sortField == 8) {
    // 默认排序
    returnParams.sortType = 1;
    returnParams.sortField = undefined;
  }

  if (sortField == 6) {
    // 升序
    returnParams.sortType = 4;
    returnParams.sortField = undefined;
  }

  if (sortField == 7) {
    // 降序
    returnParams.sortType = 3;
    returnParams.sortField = undefined;
  }

  if (categoryIds != undefined) {
    // 分类
    let categoryIds = [categoryIds];
    if (!isEmptyArr(categoryIds)) {
      returnParams.categoryIds = categoryIds;
    }

    returnParams.categoryIds = undefined;
  }

  if (currentPriceRangeStart != undefined) {
    // 分类
    returnParams.referenceLowerLimit = currentPriceRangeStart;
    returnParams.currentPriceRangeStart = undefined;
  }

  if (currentPriceRangeEnd != undefined) {
    // 分类
    returnParams.referenceUpperLimit = currentPriceRangeEnd;
    returnParams.currentPriceRangeEnd = undefined;
  }

  return returnParams;


  //sortType  childrenCateIds referenceLowerLimit referenceUpperLimit
};

// 头部title
export const setTitle = (title, imageUrl) => {
  var UA = window.navigator.userAgent.toLowerCase();
  var isAndroid = (UA && /'android'/.test(UA.split(';')[1]));
  var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA.split(';')[1]));
  var isJd = (UA && /jdapp/.test(UA));
  if (isJd) {
    setTimeout(function () {
      if (isIOS) {
        window.location.href = `openapp.jdmobile://communication?params={"action":"sh_showImgTitle","imageUrl":"${imageUrl || ''}"}`
      } else if (isAndroid) {
        let options = {
          isShow: 'Y',
          imageUrl: imageUrl || ''
        }
        try{
          window.AndroidNavi && window.AndroidNavi.setTitle(JSON.stringify(options))
        }catch (e) {

        }
      }
    }, 100)
  } else {
    document.title = title
  }
};

export const isObjectValueEqual = (a, b) => {
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length != bProps.length) {
    return false;
  }

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  return true;
};

export const isNotNull = (s) => s && (s.indexOf('none') === -1);

export const getOffsetTop = (el) => {
  return el.offsetParent
    ? el.offsetTop + getOffsetTop(el.offsetParent)
    : el.offsetTop
}

 export const toLoginPage = () => {
  const loginUrl = HostEnv.getLoginUrl();
  if (loginUrl) {
    window.location.href = loginUrl
  }
}

export const MINIPROGRAM_TYPE = {
  main: 1,
  paimai: 100,
  jingxi: 2
}

export const loadScript = (src) => {
  return new Promise(function(resolve, reject) {
    var s;
    s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

export const jdAppShare = ({
  title = '',
  img='',
  content = '',
  url = '',
  shareImg = '',
  callPanel = false,
  channel = [],
  senDirectShare = false
})  => {
  loadScript('//misc.360buyimg.com/user/haikwan/2.0.0/js/jdShare.js').then(
    () => {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('jdapp') >= 0 && typeof jdShare !== 'undefined') {

        let defaultChannel = ['Wxfriends', 'Wxmoments', 'QQfriends', 'QQzone', 'JDFamily', 'Sinaweibo', 'CopyURL'];
        if (shareImg && shareImg.length) {
          defaultChannel.push('QRCode')
        }
        const params = {
          title,
          content,
          url,
          img,
          channel: (channel || defaultChannel).join(','),
          callback: null,
          clickcallback: null,
          qrparam: shareImg && shareImg.length ? {
            mid_pic: shareImg,
            qr_direct: shareImg
          } : '',
          timeline_title: '',
        }
        if (callPanel) {
          jdShare.callSharePane(params)
        } else if(senDirectShare) {
          jdShare.sendDirectShare(params)
        } else {
          jdShare.setShareInfo(params)
        }
      }
    }
  )
}

export const getMiniProgramType = (callback) => {
  if (isInWXSQ()) {
    try {
      window.JD.wxappext.isWxapp((result) => {
        if (result) {
          // 在小程序环境
          const wxappType = parseInt(window.JD.wxappext.wxappType)
          if (wxappType === MINIPROGRAM_TYPE.main) {
            // 主站小程序
            callback && callback(MINIPROGRAM_TYPE.main)
          } else if (wxappType === MINIPROGRAM_TYPE.jingxi) {
            // 京喜小程序
            callback && callback(MINIPROGRAM_TYPE.jingxi)
          } else if (wxappType === MINIPROGRAM_TYPE.paimai) {
            // 拍卖小程序
            callback && callback(MINIPROGRAM_TYPE.paimai)
          } else {
            callback && callback(null)
          }
        } else {
          callback && callback(null)
        }
      })
    } catch (e) {
      callback && callback(null)
      console.log(e)
    }
  } else {
    callback && callback(null)
  }
}

// 获取环境信息
export const getEnv = () =>{
  let _ua = navigator.userAgent.toLowerCase();
  if(_ua.indexOf('jdapp') >= 0){
    return 'jdapp'
  }
  if(!/mobile|android/.test(_ua)){
    return 'pc';
  }else{
    if(/micromessenger(\/[\d\.]+)*/.test(_ua)){
      return 'weixin';
    }else if(/qq\/(\/[\d\.]+)*/.test(_ua) || /qzone\//.test(_ua)){
      return 'qq';
    } else {
      return 'h5';
    }
  }
}

// 唤起京东app
export const callupJDAPP = () => {
  try {
    if (getEnv() === 'jdapp' || getEnv() === 'pc') return;
    loadScript('//wq.360buyimg.com/js/common/dest/wq.imk.downloadAppPlugin.min.js').then(() => {
      // 唤起京东app使用主站引流组件，https://cf.jd.com/pages/viewpage.action?pageId=117841701
      if ($ && typeof $.downloadAppPlugInOpenApp === 'function') {
        $.downloadAppPlugInOpenApp({
          inteneUrl: 'openApp.jdMobile://virtual?', // 打开客户端协议，必配
          M_sourceFrom: 'pmmalll', // 业务标示，供app唤起后，统计使用，必配
          inteneUrlParams: {
            category: 'jump',
            des: 'm', // 表示跳转到任意m页
            url: encodeURIComponent(location.href), // 落地页自定义参数，必配
          },
          autoOpenAppEventId: 'MDownLoadFloat_AppArouse', // 自动唤起客户端EventId，这里使用默认值，必配
          autoOpenAppEventParam: null, // 打开客户端EventParam，默认为空，必配
          NoJumpDownLoadPage: true, // 不跳下载页（为false时在唤起弹窗上点击取消会自动跳到app下载页），非必配
        });
      }
    }).catch(err => {
      console.log(err)
    })
  } catch(err) {
    console.log(err)
  }
};



export const evokeAppLayerConfig = (url) =>{
  // 顶部浮层
  let tipArg1= {
    tipId : 'm_common_tip',
    downloadAppPlugIn: {
      noRecord:true,
      inteneUrl:'openapp.jdmobile://virtual?',
      inteneUrlParams:{category: 'jump',des: 'm', url}
    }
  }
  if (window.$ && window.$.downloadAppLayerConfigData) { 
    window.$.downloadAppLayerConfigData(tipArg1);
  }
}

//是否iphonex
export const isIphonex = () => {
  return /iphone/gi.test(navigator.userAgent) && window.screen && (window.screen.height / window.screen.width > 1.95);
}

//格式化日期时间
export const timeFormat=(time) => {
  if (!time) {
      return '';
  }
  var date = new Date(time);
  var Y = date.getFullYear() + '年';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日 ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  return Y + M + D + h + m;
}

//获取地址栏参数
export const getUrlParms=(name)=>{
  var url = window.location.href
  if(!url){ return null }
  var strArr = url.split("?")
  if(!strArr || strArr.length===0){ return null}
  var str = strArr && strArr[strArr.length-1]
  str = "?" + str
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = str.substr(1).match(reg);
  if(r!=null)
  return unescape(r[2]);
  return null;
}

//业务线信息
export const BUSINESS_INFO = {
  HAIGUANANDZF: {
    code: 6,
    title:"海关政府",
    adAreaId: '21003', // 广告位areaId
  },
  SIFA: {
    code: 7,
    title:"司法拍卖",
    adAreaId: '31018'
  },
  ZICHAN: {
    code: 9,
    title:"资产处置",
    adAreaId: '41014',
  },
  POCHAN: {
    code: 10,
    title:"重整与清算",
    adAreaId: '61012'
  },
}
// 业务线标签展示取值
// 8-商业资产 7-金融资产 10-国有资产 11-海关罚没 12-政府国资   1:司法拍卖
export const ASSETTYPE_INFO = {
  ZICHANBUSINESS: {
    code: 8,
    title: '商业资产',
  },
  ZICHAN: {
    code: 7,
    title: '金融资产',
  },
  GUOYOU: {
    code: 1,
    title: '国有资产',
  },
  HAIGUAN: {
    code: 11,
    title: '海关罚没',
  },
  ZHENGFU: {
    code: 12,
    title: '政府国资',
  },
  SIFA: {
    code: 13,
    title: '司法拍卖',
  },
  NONGCUN: {
    code: 20,
    title: '农村产权'
  }
}

// 机构信息
export const ORG_INFO = {
  HAIGUANANDZF: {
    code: 6,
    adAreaId: '21004', // 广告位areaId
  },
  ZICHAN: {
    code: 9,
    adAreaId: '41015',
  }
}
//是否为推介或者招募
export const ANNOUNCEMENT_INFO = {
  YES: {
    code: 1,
  },
  NO: {
    code: 0,
  }
}

//是否为中介机构选聘
export const AGENCY_INFO = {
  YES: {
    code: 1,
  },
  NO: {
    code: 0,
  }
}

//海关业务线信息
export const HAIGUANANDZF_INFO = {
  HAIGUAN: {
    customsStates: 1,
    labelSet: 1030,
    title: "海关罚没"
  },
  ZF: {
    customsStates: 2,
    labelSet: 1039,
    title: "政府物资"
  },
  GY: {
    customsStates: 3,
    labelSet: 1031,
    title: "国有资产"
  }
}

//获取查询拍品所需apiType参数
export const getApiTypeByGetItem=(publishSource)=>{
  let apiType = ''
  if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
    apiType = 12
  } else if(publishSource==BUSINESS_INFO.SIFA.code){
    apiType = 2
  } else if(publishSource==BUSINESS_INFO.ZICHAN.code){
    apiType = 9
  } else if(publishSource==BUSINESS_INFO.POCHAN.code){
    apiType = 0
  }
  return apiType
}

//获取查询拍品所需业务类型参数用于埋点
export const getBusinessTypeByMP=()=>{
  let businessType = ''
  const publishSource = unit_institution.publishSource
  const customsStates = unit_institution.customsStates
  if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
    if(customsStates==1){
      businessType = 2
    }else{
      businessType = 1
    }
  } else if(publishSource==BUSINESS_INFO.SIFA.code){
    businessType = 3
  } else if(publishSource==BUSINESS_INFO.ZICHAN.code){
    businessType = 0
  } else if(publishSource==BUSINESS_INFO.POCHAN.code){
    businessType = 1
  }
  return businessType
}

export const getRealImgPath = ({
  url,
  index,
  q = 70,
  size = '800x800',
  nx = 'esf',
  wh = ''
}) => {

  const innerUrl = url.trim()
  let returnUrl = innerUrl

  // 从公网访问图片使用的域名数组
  const domainArr = [10, 11, 12, 13, 14, 20, 30]

  // 计算图片链接hash
  const urlSplit = url.split('/')
  const hashStr = urlSplit[urlSplit.length - 1].split('.')[0]
  let total = 0
  for (let i = 0; i < hashStr.length; i++) {
    total += hashStr.charCodeAt(i)
  }

  // 获取图片使用的域名
  let selectedIndex = 0
  if (index === 0) {
    selectedIndex = 0
  } else {
    selectedIndex = index || total % domainArr.length
  }
  const randomDomain = domainArr[selectedIndex]

  // 全路径
  if (/\/jfs\//.test(innerUrl)) {
    if (/\.gif$/.test(innerUrl)) {
      returnUrl = `https://img${randomDomain}.360buyimg.com/esf/${innerUrl.split('/jfs/')[1]}${wh}`
    }
    returnUrl = `https://img${randomDomain}.360buyimg.com/${nx}/s${size}_jfs/${innerUrl.split('/jfs/')[1]}!q${q}${wh}`

  // jfs开头的路径的时候
  } if (/^jfs\//.test(innerUrl)) {
    if (/\.gif$/.test(innerUrl)) {
      returnUrl = `https://img${randomDomain}.360buyimg.com/esf/${innerUrl}${wh}`
    }

    returnUrl = `https://img${randomDomain}.360buyimg.com/${nx}/s${size}_${innerUrl}!q${q}${wh}`
  }

  return returnUrl
}

//价格展示单位转换
export const getPriceAndUnit = (currentPrice, disposeTotalUnit) => {
  let displayPrice = ''
  if (currentPrice === 0) displayPrice='0'
  if (currentPrice) {
    if (currentPrice >= 100000000) {
      // 转换为亿元,最多保留小数点后四位
      displayPrice = (Math.floor(currentPrice / 10000) / 10000).toString() + '亿'
    } else if (currentPrice >= 10000) {
      // 转换为万元，最多保留小数点后两位
      displayPrice = (Math.floor(currentPrice / 100) / 100).toString() + '万'
    } else {
      displayPrice = currentPrice.toString()
    }
  }
  
  if (disposeTotalUnit) {
    displayPrice = displayPrice + '/' + disposeTotalUnit
  }
  
  return displayPrice
}
/**
 * 防抖函数 - 在一定时间内多次触发只执行最后一次
 * @param {Function} func 需要防抖的函数
 * @param {number} wait 等待时间(毫秒)
 * @param {boolean} immediate 是否立即执行
 * @returns {Function} 返回防抖处理后的函数，该函数具有cancel方法用于取消等待执行的函数
 */
export const debounce = (func, wait, immediate = false) => {
  let timeout;
  
  const debounced = function(...args) {
    const context = this;
    
    // 清除之前的延时调用
    if (timeout) clearTimeout(timeout);
    
    if (immediate) {
      // 立即执行版本
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      
      if (callNow) func.apply(context, args);
    } else {
      // 非立即执行版本
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };

  // 添加取消方法
  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
};
/**
 * 金融App分享功能
 * 基于京东金融JS-SDK实现原生分享面板调起
 * @param {Object} shareData - 分享数据配置
 * @param {string} shareData.title - 分享标题
 * @param {string} shareData.content - 分享内容描述
 * @param {string} shareData.url - 分享链接
 * @param {string} shareData.imageUrl - 分享缩略图(必须为https地址，小于32k)
 * @param {boolean} shareData.isLogin - 是否需要登录 (0不需要 1需要)
 * @param {Function} callback - 分享结果回调函数
 */
export const jdFinanceAppShare = ({
  title = '',
  content = '',
  url = '',
  imageUrl = '',
  isLogin = '0',
  callback = null
}) => {
  // 检查是否在金融App环境中
  if (!isJdjrApp()) {
    console.warn('当前不在京东金融App环境中，无法使用金融App分享功能');
    return false;
  }

  // 检查JrBridge是否可用
  if (typeof window.JrBridge === 'undefined' || typeof window.JrBridge.callNative !== 'function') {
    console.error('JrBridge未初始化，请确保已正确引入京东金融JS-SDK');
    return false;
  }

  // 验证必要参数
  if (!title || !content || !url || !imageUrl) {
    console.error('金融App分享缺少必要参数: title, content, url, imageUrl');
    return false;
  }

  // 验证图片URL格式
  if (!imageUrl.startsWith('https://')) {
    console.error('分享缩略图必须为https地址');
    return false;
  }

  try {
    // 构建分享参数，严格按照SDK文档格式
    const shareParams = {
      type: '4', // 固定字段，表示页面内按钮唤起分享面板
      shareDataNew: {
        showAdjustFont: false, // 是否设置字号
        showTools: false, // 是否展示工具栏
        imageUrl: imageUrl, // 分享缩略图，必须为https地址，小于32k
        linkSubtitle: content, // 分享副标题
        linkTitle: title, // 分享主标题
        isLogin: isLogin, // 唤起分享面板时是否需要登录
        channelList: [
          {
            shareType: 0, // 固定字段，传0代表分享url地址
            id: '1', // 分享渠道，固定字段传1即可
            link: url // 分享出去的链接地址
          }
        ]
      }
    };

    // 调用金融App原生分享面板
    window.JrBridge.callNative(shareParams, function(data) {
      try {
        // 处理回调数据
        if (typeof data !== 'object') {
          data = JSON.parse(data);
        }

        if (data.share) {
          const shareState = parseInt(data.share.shareState);
          const sharePlat = parseInt(data.share.sharePlat);
          
          // 分享状态处理
          let result = {
            success: false,
            state: shareState,
            platform: sharePlat,
            message: ''
          };

          switch (shareState) {
            case 1:
              result.message = '分享已发出';
              result.success = true;
              break;
            case 2:
              result.message = '分享成功';
              result.success = true;
              break;
            case 3:
              result.message = '分享失败';
              result.success = false;
              break;
            default:
              result.message = '未知分享状态';
              result.success = false;
          }

          // 平台信息映射
          const platformMap = {
            1: '微信朋友圈',
            2: '微信好友',
            3: '新浪微博',
            4: '短信',
            5: 'QQ好友',
            6: 'QQ空间',
            8: '花生社区',
            9: '图片分享',
            11: '系统分享'
          };
          
          result.platformName = platformMap[sharePlat] || '未知平台';

          // 执行回调
          if (typeof callback === 'function') {
            callback(result);
          }

          console.log('金融App分享结果:', result);
        }
      } catch (error) {
        console.error('金融App分享回调处理错误:', error);
        if (typeof callback === 'function') {
          callback({
            success: false,
            message: '分享回调处理失败',
            error: error.message
          });
        }
      }
    });

    return true;
  } catch (error) {
    console.error('金融App分享调用失败:', error);
    if (typeof callback === 'function') {
      callback({
        success: false,
        message: '分享调用失败',
        error: error.message
      });
    }
    return false;
  }
};

/**
 * 检查是否支持金融App分享功能
 * @returns {boolean} 是否支持金融App分享
 */
export const isJdFinanceAppShareSupported = () => {
  return isJdjrApp() && 
         typeof window.JrBridge !== 'undefined' && 
         typeof window.JrBridge.callNative === 'function';
};

/**
 * 统一分享函数 - 自动适配不同App环境
 * @param {Object} shareData - 分享数据
 * @param {Function} callback - 回调函数
 */
export const universalAppShare = (shareData, callback) => {
  const { title, content, url, imageUrl } = shareData;

  // 优先使用金融App分享
  if (isJdFinanceAppShareSupported()) {
    return jdFinanceAppShare({
      title,
      content,
      url,
      imageUrl,
      callback
    });
  }
  
  // 回退到京东App分享
  if (isJdapp()) {
    return jdAppShare({
      title,
      img: imageUrl,
      content,
      url,
      callPanel: true
    });
  }

  // 其他环境的处理
  console.warn('当前环境不支持App原生分享功能');
  return false;
};

/**
 * 判断是否是债权类目
 * @param {*} templateType 模板类型：1：债权类模板值  2：股权/租赁权   3:默认模版
 * @returns 
 */
export const isZhaiquanCategory = (templateType) => {
  return templateType === 1

}